/* Sokong Lokal analytics + lite YouTube loader. No dependencies.
   Events are pushed to window.dataLayer so the store's existing GA4/GTM consent setup decides what fires. */
(function () {
  if (window.__sokongLokalInit) return;
  window.__sokongLokalInit = true;
  function track(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }
  document.addEventListener('DOMContentLoaded', function () {
    track('sokong_lokal_view', { page_path: location.pathname, source: document.referrer || '' });
  });
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-sl-event]');
    if (!el) return;
    var params = {};
    Object.keys(el.dataset).forEach(function (k) {
      if (k !== 'slEvent' && k.indexOf('sl') === 0) {
        var key = k.slice(2).replace(/[A-Z]/g, function (m) { return '_' + m.toLowerCase(); }).replace(/^_/, '');
        params[key] = el.dataset[k];
      }
    });
    if (el.href) params.destination_url = el.href;
    track(el.dataset.slEvent, params);
  });
  // A hidden cut must never keep playing after a viewport change.
  var filmViewport = window.matchMedia('(min-width: 990px)');
  function pauseHiddenFilms() {
    var hidden = filmViewport.matches ? '.sl-film__media--mobile video' : '.sl-film__media--desktop video';
    document.querySelectorAll(hidden).forEach(function (video) { video.pause(); });
  }
  filmViewport.addEventListener('change', pauseHiddenFilms);
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.sl-film__video').forEach(function (video) { video.pause(); });
  });
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v.matches || !v.matches('.sl-film__video') || v.__slTracked) return;
    v.__slTracked = true;
    track('sokong_lokal_video_play', { video_title: v.getAttribute('data-sl-video-title') || 'Sokong Lokal brand film', video_url: v.currentSrc || '' });
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sl-youtube]');
    if (!btn) return;
    var id = btn.getAttribute('data-sl-youtube');
    var title = btn.getAttribute('data-sl-title') || 'Sokong Lokal brand film';
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
    frame.title = title;
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    frame.setAttribute('allowfullscreen', '');
    btn.parentNode.replaceChild(frame, btn);
    track('sokong_lokal_video_play', { video_title: title, video_url: 'https://youtu.be/' + id });
  });
})();
